/* Replaced in the "GE — machine pages" theme: the quote list now lives in gm-quote.js (storage key gm_quote_v1), which also updates the header's [data-quote-count]. */
(function () {
  function sync() {
    var n = 0;
    try { (JSON.parse(localStorage.getItem('gm_quote_v1')) || []).forEach(function (i) { n += i.qty || 1; }); } catch (e) {}
    document.querySelectorAll('[data-quote-count]').forEach(function (c) { c.textContent = n; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  document.addEventListener('click', function () { setTimeout(sync, 50); });
})();
